import React, { useState, useEffect } from "react";

interface NumberPadProps {
  value: string;
  onChange: (value: string) => void;
  onClose: () => void;
}

const NumberPad: React.FC<NumberPadProps> = ({ value, onChange, onClose }) => {
  const numbers = ["7", "8", "9", "4", "5", "6", "1", "2", "3", "0", "."];

  const [inputValue, setInputValue] = useState<string>(value || "");
  const [freshInput, setFreshInput] = useState(true);

  useEffect(() => {
    setInputValue(value || "");
    setFreshInput(true);
  }, [value]);

  const handlePress = (key: string) => {
    if (key === "clear") {
      setInputValue("");
      setFreshInput(true);
      return;
    }

    if (key === "back") {
      setInputValue((prev) => prev.slice(0, -1));
      return;
    }

    if (key === "." && inputValue.includes(".")) return;

    if (freshInput) {
      setInputValue(key === "." ? "0." : key);
      setFreshInput(false);
    } else {
      setInputValue((prev) => prev + key);
    }
  };

  return (
    <div className='fixed inset-0 bg-black/20 flex items-center justify-center z-50'>
      <div className='bg-white p-4 rounded-xl shadow-xl w-72'>
        <div className='mb-3 text-right border p-3 rounded bg-gray-100 text-xl font-semibold'>{inputValue || "0"}</div>

        <div className='grid grid-cols-3 gap-2'>
          {numbers.map((num) => (
            <button key={num} className='p-3 bg-gray-200 rounded text-lg font-semibold' onClick={() => handlePress(num)}>
              {num}
            </button>
          ))}

          <button className='p-3 bg-yellow-400 rounded font-semibold' onClick={() => handlePress("back")}>
            ⌫
          </button>

          <button className='p-3 bg-red-500 text-white rounded font-semibold' onClick={() => handlePress("clear")}>
            C
          </button>

          <button
            className='p-3 bg-green-600 text-white rounded font-semibold'
            onClick={() => {
              onChange(inputValue);
              onClose();
            }}
          >
            OK
          </button>
          <button
            className='p-3 bg-green-400 text-white rounded font-semibold'
            onClick={() => {
              setInputValue(value);
            }}
          >
            Reset
          </button>
        </div>
      </div>
    </div>
  );
};

export default NumberPad;
